import React from 'react'
import { useTranslation } from 'react-i18next'
import { Markup } from 'interweave'
import { Button } from '@mui/material'
import Error from '../assets/svg/error.svg'

interface ErrorFormProps {
  handleSuccess: () => void
  error?: string[]
}

const ErrorForm = ({ handleSuccess, error }: ErrorFormProps) => {
  const { t } = useTranslation()
  return (
    <div className='flex flex-col px-4 flex-auto my-16 w-full items-center justify-center'>
      <div className='d-flex md:mx-0 px-4 py-4 sm:px-11 container sm:py-11 mb-24 rounded-2xl w-full bg-white border-[1px] border-fireRed-100 shadow'>
        <div className='border-[2px] sm:px-[48px] border-fireRed px-8 py-8 sm:py-[80px] w-full flex flex-col items-center justify-center'>
          <img src={Error} alt='Error' />
          <div className='text-center my-8'>
            <div className='text-center font-nexaBold text-fireRed text-[18px] sm:text-[36px]'>
              <Markup
                content={
                  error && error.includes('error.ApproveError')
                    ? t('p2p-page.error.approveError')
                    : t('p2p-page.error.title')
                }
              />
            </div>
            {error &&
              error.map((item) => (
                <div className='text-main text-center font-nexaBold text-[14px] sm:text-[14px] mt-4'>
                  <Markup content={t(`${item}`)} />
                </div>
              ))}
          </div>
          <Button variant='contained' className='mt-8 sm:w-2/4 w-full' onClick={handleSuccess}>
            <Markup content={t('p2p-page.error.button')} />
          </Button>
          <a
            href='tel:+1313'
            className='text-center mt-8 sm:w-2/4 w-full rounded-[30px] hover:border-secondary border-gray-500 border-[1px]'
          >
            <div className='text-main text-center font-nexaBold text-[16px] py-3 sm:py-[20px]'>
              {t('p2p-page.error.button2')}
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

ErrorForm.defaultProps = {
  error: undefined,
}

export default ErrorForm
